const PROJECT_ATTACHMENTS = {
  DOCUMENT: 'DOCUMENT',
  LINK: 'LINK',
};

export {
  PROJECT_ATTACHMENTS,
};
